import { FC, ReactNode } from 'react'

import { CommunicationQRCode, CommunicationQRCodeType } from './QRCode'
import { DownloadLinkCard, DownloadLinkCardType } from './DownloadLinkCard'
import {
  CommunicationSmartBanners,
  CommunicationSmartBannersType,
} from './SmartBanners'

const Communication: FC &
  CommunicationQRCodeType &
  CommunicationSmartBannersType &
  DownloadLinkCardType = (): ReactNode => <></>

Communication.QRCode = CommunicationQRCode
Communication.DownloadLinkCard = DownloadLinkCard
Communication.SmartBanners = CommunicationSmartBanners

export default Communication
